<app-modal-filler-atom
  (click)="closeFilters()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed min-h-screen top-0 bottom-0 left-0 right-0 lg:right-0 lg:top-0 lg:bottom-0 lg:left-auto lg:w-4/12 bg-white overflow-y-auto overflow-x-hidden"
  [style.z-index]="(index$ | async) + 50"
>
  <header class="flex items-center justify-between px-5 py-3 shadow-md">
    <!-- <app-input-text-atom class="w-full mr-5" [label]="'Restaurants, plats...'" [iconLeft]="'icon-zoom'" [value]=""></app-input-text-atom> -->
    <div></div>
    <span
      class="icon icon-cross cursor-pointer"
      (click)="closeFilters()"
    ></span>
  </header>
  <div class="px-5 min-h-full">
    <div class="py-3">
      <app-horizontal-categories-atom
        [items]="categoryItems"
        [mobileView]="true"
        (clickCard)="selectCategory($event)"
      ></app-horizontal-categories-atom>
    </div>
    <div *ngFor="let filter of filters">
      <app-toggle-filter-atom
        [name]="filter.label | translate"
        [type]="filter.type"
        [multiSelect]="filter.multiSelect"
        [items]="filter.values"
        [id]="filter.id"
        [initItemValues]="selectedFilters$ | async"
        (selectedItemsChange)="updateFilters($event)"
      ></app-toggle-filter-atom>
    </div>
  </div>
  <footer class="sticky bottom-0 left-0 bg-white shadow shadow-top">
    <div class="flex flex-nowrap p-3 w-full">
      <app-button-atom
        class="w-full mr-3"
        [type]="'light'"
        [color]="'primary'"
        [label]="'filters.delete-all' | translate"
        [size]="'L'"
        [full]="true"
        (click)="removeFilters()"
      ></app-button-atom>
      <app-button-atom
        class="w-full"
        [type]="'primary'"
        [color]="'primary'"
        [label]="'filters.apply' | translate"
        [size]="'L'"
        [full]="true"
        (click)="applyFilters()"
      ></app-button-atom>
    </div>
  </footer>
</div>
